import { AdminToken } from '_constants';
import { Login } from 'components/templates';
import React from 'react';

import { LoginViewBox } from './styles';

export const LoginView = () => {
  localStorage.removeItem(AdminToken);
  return (
    <LoginViewBox>
      <Login />
    </LoginViewBox>
  );
};
